/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Subtitle_Max_Chars_HelpInputs */



/**
* | output |
* | --- |
* | "Characters per line" |
*
* @param {Audio_Description_Export_Subtitle_Max_Chars_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_subtitle_max_chars_help = /** @type {((inputs?: Audio_Description_Export_Subtitle_Max_Chars_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Subtitle_Max_Chars_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Caractères par ligne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeichen pro Zeile")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caratteri per riga")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Символов в строке")
	if (locale === "es") return /** @type {LocalizedString} */ ("Caracteres por línea")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("每行字符数")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1行あたりの文字数")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रति पंक्ति वर्ण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Caracteres por linha")
	return /** @type {LocalizedString} */ ("Characters per line")
});